import { useEffect, useState } from "react";

const ReleaseDate = (props) => {
  const { mix, date, isMobile } = props;

  const [formattedDate, setFormattedDate] = useState();

  useEffect(() => {
    // const date = new Date(mix.created_at);

    // function getOrdinal(n) {
    //   const s = ["th", "st", "nd", "rd"];
    //   const v = n % 100;
    //   return s[(v - 20) % 10] || s[v] || s[0];
    // }

    // // Format the date
    // const options = { month: "short" };
    // const month = new Intl.DateTimeFormat("en-US", options).format(date);
    // const day = date.getDate();
    // const year = date.getFullYear();
    // setFormattedDate(`${month} ${day}${getOrdinal(day)}, ${year}`)

    const day = mix.releaseDay;
    const year = mix.releaseYear;
    const month = new Date(2000, mix.releaseMonth - 1).toLocaleString("en-US", {
      month: "short",
    });
    const mobMonth = String(mix.releaseMonth).padStart(2, '0');

    const getOrdinal = (n) => {
      if (n >= 11 && n <= 13) return "th";
      switch (n % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    // if(mix.releaseDate){
      // setFormattedDate(date)
    // }

    if (!isMobile) {
      setFormattedDate(`${month} ${day}${getOrdinal(day)}, ${year}`);
    } else {
      setFormattedDate(`${day}/${mobMonth}/${year}`);
    }

  }, [date]);

  return formattedDate;
};

export default ReleaseDate;
